import { defineComponent as f, ref as g, computed as b, h as t } from "vue";
import { normalizeAlpha as v } from "./ghl-ui.es914.js";
import { toRgbaString as $ } from "./ghl-ui.es904.js";
import { on as s, off as u } from "./ghl-ui.es710.js";
const i = "12px", y = 12, r = "6px", _ = f({
  name: "AlphaSlider",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    rgba: {
      type: Array,
      default: null
    },
    alpha: {
      type: Number,
      default: 0
    },
    onUpdateAlpha: {
      type: Function,
      required: !0
    },
    onComplete: Function
  },
  setup(o) {
    const l = g(null);
    function c(e) {
      !l.value || !o.rgba || (s("mousemove", document, n), s("mouseup", document, a), n(e));
    }
    function n(e) {
      const {
        value: d
      } = l;
      if (!d)
        return;
      const {
        width: h,
        left: p
      } = d.getBoundingClientRect(), m = (e.clientX - p) / (h - y);
      o.onUpdateAlpha(v(m));
    }
    function a() {
      var e;
      u("mousemove", document, n), u("mouseup", document, a), (e = o.onComplete) === null || e === void 0 || e.call(o);
    }
    return {
      railRef: l,
      railBackgroundImage: b(() => {
        const {
          rgba: e
        } = o;
        return e ? `linear-gradient(to right, rgba(${e[0]}, ${e[1]}, ${e[2]}, 0) 0%, rgba(${e[0]}, ${e[1]}, ${e[2]}, 1) 100%)` : "";
      }),
      handleMouseDown: c
    };
  },
  render() {
    const {
      clsPrefix: o
    } = this;
    return t("div", {
      class: `${o}-color-picker-slider`,
      ref: "railRef",
      style: {
        height: i,
        borderRadius: r
      },
      onMousedown: this.handleMouseDown
    }, t("div", {
      style: {
        borderRadius: r,
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        overflow: "hidden"
      }
    }, t("div", {
      class: `${o}-color-picker-checkboard`
    }), t("div", {
      class: `${o}-color-picker-slider__image`,
      style: {
        backgroundImage: this.railBackgroundImage
      }
    })), this.rgba && t("div", {
      style: {
        position: "absolute",
        left: r,
        right: r,
        top: 0,
        bottom: 0
      }
    }, t("div", {
      class: `${o}-color-picker-handle`,
      style: {
        left: `calc(${this.alpha * 100}% - ${r})`,
        borderRadius: r,
        width: i,
        height: i
      }
    }, t("div", {
      class: `${o}-color-picker-handle__fill`,
      style: {
        backgroundColor: $(this.rgba),
        borderRadius: r,
        width: i,
        height: i
      }
    }))));
  }
});
export {
  _ as default
};
